import createIcon from '../../createIcon';

/**
 * @component @name RealEstateAgent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMS41IDIyLjI1SDUuNVYxMS4yNUgxLjVWMjIuMjVaTTIwLjUgMTcuMjVIMTMuNUwxMS40MSAxNi41MkwxMS43NCAxNS41OEwxMy41IDE2LjI1SDE2LjMyQzE2Ljk3IDE2LjI1IDE3LjUgMTUuNzIgMTcuNSAxNS4wN0MxNy41IDE0LjU4IDE3LjE5IDE0LjE0IDE2LjczIDEzLjk2TDkuNDcgMTEuMjVINy41VjIwLjI3TDE0LjUgMjIuMjVMMjIuNSAxOS4yNUMyMi40OSAxOC4xNSAyMS42MSAxNy4yNSAyMC41IDE3LjI1Wk0xNC41IDEuNzVMNy41IDYuNzVWOS4yNUg5LjVMMTcuNjQgMTIuNTFDMTguNzYgMTIuOTYgMTkuNSAxNC4wNCAxOS41IDE1LjI1SDIxLjVWNi43NUwxNC41IDEuNzVaTTE0IDEwLjI1SDEzVjkuMjVIMTRWMTAuMjVaTTE0IDguMjVIMTNWNy4yNUgxNFY4LjI1Wk0xNiAxMC4yNUgxNVY5LjI1SDE2VjEwLjI1Wk0xNiA4LjI1SDE1VjcuMjVIMTZWOC4yNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RealEstateAgent = createIcon('RealEstateAgent', [
  [
    'path',
    {
      d: 'M1.5 22.25H5.5V11.25H1.5V22.25ZM20.5 17.25H13.5L11.41 16.52L11.74 15.58L13.5 16.25H16.32C16.97 16.25 17.5 15.72 17.5 15.07C17.5 14.58 17.19 14.14 16.73 13.96L9.47 11.25H7.5V20.27L14.5 22.25L22.5 19.25C22.49 18.15 21.61 17.25 20.5 17.25ZM14.5 1.75L7.5 6.75V9.25H9.5L17.64 12.51C18.76 12.96 19.5 14.04 19.5 15.25H21.5V6.75L14.5 1.75ZM14 10.25H13V9.25H14V10.25ZM14 8.25H13V7.25H14V8.25ZM16 10.25H15V9.25H16V10.25ZM16 8.25H15V7.25H16V8.25Z',
      key: '7ubj1o',
    },
  ],
]);

export default RealEstateAgent;
